import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 'calc(100vw - 8rem)',

    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100vw - 1rem)'
    },

    '& .table-root': {
      minHeight: ({ loaded }) => (loaded ? 'unset' : '10rem')
    },

    '& .bottomRow': {
      '& .children': {
        width: '100%'
      }
    }
  }
}))

export default useStyles
